/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type registrationFor_enum = "minor" | "other_user" | "self" | "%future added value";
export type registrationStatus_enum = "canceled" | "canceled_stale" | "complete" | "in_progress" | "%future added value";
export type roleOrganizer_enum = "Admin" | "Coach" | "Owner" | "Support" | "Timing" | "Volunteer" | "%future added value";
export type AuthProviderQueryVariables = {
    userId: string;
};
export type AuthProviderQueryResponse = {
    readonly user_connection: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly timezone: string;
                readonly isAdmin: boolean;
                readonly isCoach: boolean;
                readonly isCreator: boolean;
                readonly slug: string;
                readonly email: string;
                readonly firstName: string | null;
                readonly lastName: string | null;
                readonly idealRide: string | null;
                readonly cyclingGoal: string | null;
                readonly dob: string | null;
                readonly phone: string | null;
                readonly currency: string;
                readonly profilePicUrl: string | null;
                readonly showSetupCoach: boolean;
                readonly selectedOrganizerSlug: string | null;
                readonly stripeConnectId: string | null;
                readonly stripeIdentityVerificationStatus: string | null;
                readonly stripeIdentityVerificationError: string | null;
                readonly stripeIdentityVerificationSessionId: string | null;
                readonly userAddresses: ReadonlyArray<{
                    readonly isDefault: boolean;
                    readonly city: string | null;
                    readonly state: string | null;
                    readonly country: string;
                    readonly zipCode: string | null;
                    readonly countryCode: string;
                }>;
                readonly stripeConnectAccount: {
                    readonly accountId: string;
                    readonly ownerUserId: string | null;
                    readonly chargesEnabled: boolean;
                    readonly payoutsEnabled: boolean;
                } | null;
                readonly coach: {
                    readonly id: string;
                    readonly cuid: string;
                    readonly currencyCode: string;
                    readonly allowRequests: boolean;
                    readonly showProfileHelpBanner: boolean;
                    readonly coachLocations: ReadonlyArray<{
                        readonly timezone: string;
                    }>;
                    readonly coachDisciplines: ReadonlyArray<{
                        readonly name: string;
                        readonly skills: Record<string, unknown> | unknown[];
                    }>;
                } | null;
                readonly userSavedEvents: ReadonlyArray<{
                    readonly id: string;
                    readonly cuid: string;
                    readonly eventCuid: string;
                }>;
                readonly userOrganizerRoles: ReadonlyArray<{
                    readonly organizerCuid: string | null;
                    readonly role: roleOrganizer_enum;
                    readonly organizer: {
                        readonly id: string;
                        readonly cuid: string;
                        readonly name: string;
                        readonly slug: string;
                        readonly showOnboarding: boolean;
                        readonly events: ReadonlyArray<{
                            readonly cuid: string;
                            readonly eventMetadata: {
                                readonly slug: string;
                            };
                        }>;
                    } | null;
                }>;
                readonly registrations: ReadonlyArray<{
                    readonly status: registrationStatus_enum;
                    readonly for: registrationFor_enum;
                    readonly eventCuid: string;
                    readonly rideCuid: string | null;
                    readonly clinicCuid: string | null;
                }>;
                readonly userRidingInterests: ReadonlyArray<{
                    readonly disciplineName: string;
                    readonly focus: Record<string, unknown> | unknown[];
                    readonly hasAbilityGoal: boolean;
                    readonly abilityLevel: Record<string, unknown> | unknown[];
                    readonly abilityLevelGoal: Record<string, unknown> | unknown[];
                }>;
            };
        }>;
    };
};
export type AuthProviderQuery = {
    readonly response: AuthProviderQueryResponse;
    readonly variables: AuthProviderQueryVariables;
};



/*
query AuthProviderQuery(
  $userId: String!
) {
  user_connection(where: {id: {_eq: $userId}}) {
    edges {
      node {
        id
        timezone
        isAdmin
        isCoach
        isCreator
        slug
        email
        firstName
        lastName
        idealRide
        cyclingGoal
        dob
        phone
        currency
        profilePicUrl
        showSetupCoach
        selectedOrganizerSlug
        stripeConnectId
        stripeIdentityVerificationStatus
        stripeIdentityVerificationError
        stripeIdentityVerificationSessionId
        userAddresses(where: {isDefault: {_eq: true}}) {
          isDefault
          city
          state
          country
          zipCode
          countryCode
          id
        }
        stripeConnectAccount {
          accountId
          ownerUserId
          chargesEnabled
          payoutsEnabled
          id
        }
        coach {
          id
          cuid
          currencyCode
          allowRequests
          showProfileHelpBanner
          coachLocations(limit: 1) {
            timezone
            id
          }
          coachDisciplines(limit: 1) {
            name
            skills
            id
          }
        }
        userSavedEvents(order_by: {created_at: asc}) {
          id
          cuid
          eventCuid
        }
        userOrganizerRoles(where: {organizer: {deleted_at: {_is_null: true}}}, order_by: [{organizer: {created_at: asc}}]) {
          organizerCuid
          role
          organizer {
            id
            cuid
            name
            slug
            showOnboarding
            events(where: {deleted_at: {_is_null: true}, clinics: {clinicCoaches: {coach: {userId: {_eq: $userId}}}}}) {
              cuid
              eventMetadata {
                slug
                id
              }
              id
            }
          }
          id
        }
        registrations {
          status
          for
          eventCuid
          rideCuid
          clinicCuid
          id
        }
        userRidingInterests {
          disciplineName
          focus
          hasAbilityGoal
          abilityLevel
          abilityLevelGoal
          id
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "_eq",
            "variableName": "userId"
        } as any
    ], v2 = [
        {
            "fields": [
                {
                    "fields": (v1 /*: any*/),
                    "kind": "ObjectValue",
                    "name": "id"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        } as any
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timezone",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAdmin",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isCoach",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isCreator",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "idealRide",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cyclingGoal",
        "storageKey": null
    } as any, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dob",
        "storageKey": null
    } as any, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phone",
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profilePicUrl",
        "storageKey": null
    } as any, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "showSetupCoach",
        "storageKey": null
    } as any, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "selectedOrganizerSlug",
        "storageKey": null
    } as any, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stripeConnectId",
        "storageKey": null
    } as any, v21 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stripeIdentityVerificationStatus",
        "storageKey": null
    } as any, v22 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stripeIdentityVerificationError",
        "storageKey": null
    } as any, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stripeIdentityVerificationSessionId",
        "storageKey": null
    } as any, v24 = [
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "isDefault": {
                    "_eq": true
                }
            }
        } as any
    ], v25 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDefault",
        "storageKey": null
    } as any, v26 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "city",
        "storageKey": null
    } as any, v27 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
    } as any, v28 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "country",
        "storageKey": null
    } as any, v29 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "zipCode",
        "storageKey": null
    } as any, v30 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "countryCode",
        "storageKey": null
    } as any, v31 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountId",
        "storageKey": null
    } as any, v32 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ownerUserId",
        "storageKey": null
    } as any, v33 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "chargesEnabled",
        "storageKey": null
    } as any, v34 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "payoutsEnabled",
        "storageKey": null
    } as any, v35 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cuid",
        "storageKey": null
    } as any, v36 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currencyCode",
        "storageKey": null
    } as any, v37 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowRequests",
        "storageKey": null
    } as any, v38 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "showProfileHelpBanner",
        "storageKey": null
    } as any, v39 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 1
        } as any
    ], v40 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v41 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "skills",
        "storageKey": null
    } as any, v42 = {
        "created_at": "asc"
    } as any, v43 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventCuid",
        "storageKey": null
    } as any, v44 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "order_by",
                "value": (v42 /*: any*/)
            }
        ],
        "concreteType": "userSavedEvent",
        "kind": "LinkedField",
        "name": "userSavedEvents",
        "plural": true,
        "selections": [
            (v3 /*: any*/),
            (v35 /*: any*/),
            (v43 /*: any*/)
        ],
        "storageKey": "userSavedEvents(order_by:{\"created_at\":\"asc\"})"
    } as any, v45 = {
        "_is_null": true
    } as any, v46 = [
        {
            "kind": "Literal",
            "name": "order_by",
            "value": [
                {
                    "organizer": (v42 /*: any*/)
                }
            ]
        } as any,
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "organizer": {
                    "deleted_at": (v45 /*: any*/)
                }
            }
        } as any
    ], v47 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizerCuid",
        "storageKey": null
    } as any, v48 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
    } as any, v49 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "showOnboarding",
        "storageKey": null
    } as any, v50 = [
        {
            "fields": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "fields": [
                                        {
                                            "fields": (v1 /*: any*/),
                                            "kind": "ObjectValue",
                                            "name": "userId"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "coach"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "clinicCoaches"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "clinics"
                },
                {
                    "kind": "Literal",
                    "name": "deleted_at",
                    "value": (v45 /*: any*/)
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        } as any
    ], v51 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any, v52 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "for",
        "storageKey": null
    } as any, v53 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rideCuid",
        "storageKey": null
    } as any, v54 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clinicCuid",
        "storageKey": null
    } as any, v55 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "disciplineName",
        "storageKey": null
    } as any, v56 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "focus",
        "storageKey": null
    } as any, v57 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasAbilityGoal",
        "storageKey": null
    } as any, v58 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "abilityLevel",
        "storageKey": null
    } as any, v59 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "abilityLevelGoal",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AuthProviderQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": "userConnection",
                    "kind": "LinkedField",
                    "name": "user_connection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "userEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "user",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        (v4 /*: any*/),
                                        (v5 /*: any*/),
                                        (v6 /*: any*/),
                                        (v7 /*: any*/),
                                        (v8 /*: any*/),
                                        (v9 /*: any*/),
                                        (v10 /*: any*/),
                                        (v11 /*: any*/),
                                        (v12 /*: any*/),
                                        (v13 /*: any*/),
                                        (v14 /*: any*/),
                                        (v15 /*: any*/),
                                        (v16 /*: any*/),
                                        (v17 /*: any*/),
                                        (v18 /*: any*/),
                                        (v19 /*: any*/),
                                        (v20 /*: any*/),
                                        (v21 /*: any*/),
                                        (v22 /*: any*/),
                                        (v23 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": (v24 /*: any*/),
                                            "concreteType": "userAddress",
                                            "kind": "LinkedField",
                                            "name": "userAddresses",
                                            "plural": true,
                                            "selections": [
                                                (v25 /*: any*/),
                                                (v26 /*: any*/),
                                                (v27 /*: any*/),
                                                (v28 /*: any*/),
                                                (v29 /*: any*/),
                                                (v30 /*: any*/)
                                            ],
                                            "storageKey": "userAddresses(where:{\"isDefault\":{\"_eq\":true}})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "stripeConnectAccount",
                                            "kind": "LinkedField",
                                            "name": "stripeConnectAccount",
                                            "plural": false,
                                            "selections": [
                                                (v31 /*: any*/),
                                                (v32 /*: any*/),
                                                (v33 /*: any*/),
                                                (v34 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "coach",
                                            "kind": "LinkedField",
                                            "name": "coach",
                                            "plural": false,
                                            "selections": [
                                                (v3 /*: any*/),
                                                (v35 /*: any*/),
                                                (v36 /*: any*/),
                                                (v37 /*: any*/),
                                                (v38 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": (v39 /*: any*/),
                                                    "concreteType": "coachLocation",
                                                    "kind": "LinkedField",
                                                    "name": "coachLocations",
                                                    "plural": true,
                                                    "selections": [
                                                        (v4 /*: any*/)
                                                    ],
                                                    "storageKey": "coachLocations(limit:1)"
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v39 /*: any*/),
                                                    "concreteType": "coachDiscipline",
                                                    "kind": "LinkedField",
                                                    "name": "coachDisciplines",
                                                    "plural": true,
                                                    "selections": [
                                                        (v40 /*: any*/),
                                                        (v41 /*: any*/)
                                                    ],
                                                    "storageKey": "coachDisciplines(limit:1)"
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        (v44 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": (v46 /*: any*/),
                                            "concreteType": "userOrganizerRole",
                                            "kind": "LinkedField",
                                            "name": "userOrganizerRoles",
                                            "plural": true,
                                            "selections": [
                                                (v47 /*: any*/),
                                                (v48 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "organizer",
                                                    "kind": "LinkedField",
                                                    "name": "organizer",
                                                    "plural": false,
                                                    "selections": [
                                                        (v3 /*: any*/),
                                                        (v35 /*: any*/),
                                                        (v40 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v49 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": (v50 /*: any*/),
                                                            "concreteType": "event",
                                                            "kind": "LinkedField",
                                                            "name": "events",
                                                            "plural": true,
                                                            "selections": [
                                                                (v35 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "eventMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "eventMetadata",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v8 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "userOrganizerRoles(order_by:[{\"organizer\":{\"created_at\":\"asc\"}}],where:{\"organizer\":{\"deleted_at\":{\"_is_null\":true}}})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "registration",
                                            "kind": "LinkedField",
                                            "name": "registrations",
                                            "plural": true,
                                            "selections": [
                                                (v51 /*: any*/),
                                                (v52 /*: any*/),
                                                (v43 /*: any*/),
                                                (v53 /*: any*/),
                                                (v54 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "userRidingInterest",
                                            "kind": "LinkedField",
                                            "name": "userRidingInterests",
                                            "plural": true,
                                            "selections": [
                                                (v55 /*: any*/),
                                                (v56 /*: any*/),
                                                (v57 /*: any*/),
                                                (v58 /*: any*/),
                                                (v59 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "query_root",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AuthProviderQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": "userConnection",
                    "kind": "LinkedField",
                    "name": "user_connection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "userEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "user",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        (v4 /*: any*/),
                                        (v5 /*: any*/),
                                        (v6 /*: any*/),
                                        (v7 /*: any*/),
                                        (v8 /*: any*/),
                                        (v9 /*: any*/),
                                        (v10 /*: any*/),
                                        (v11 /*: any*/),
                                        (v12 /*: any*/),
                                        (v13 /*: any*/),
                                        (v14 /*: any*/),
                                        (v15 /*: any*/),
                                        (v16 /*: any*/),
                                        (v17 /*: any*/),
                                        (v18 /*: any*/),
                                        (v19 /*: any*/),
                                        (v20 /*: any*/),
                                        (v21 /*: any*/),
                                        (v22 /*: any*/),
                                        (v23 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": (v24 /*: any*/),
                                            "concreteType": "userAddress",
                                            "kind": "LinkedField",
                                            "name": "userAddresses",
                                            "plural": true,
                                            "selections": [
                                                (v25 /*: any*/),
                                                (v26 /*: any*/),
                                                (v27 /*: any*/),
                                                (v28 /*: any*/),
                                                (v29 /*: any*/),
                                                (v30 /*: any*/),
                                                (v3 /*: any*/)
                                            ],
                                            "storageKey": "userAddresses(where:{\"isDefault\":{\"_eq\":true}})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "stripeConnectAccount",
                                            "kind": "LinkedField",
                                            "name": "stripeConnectAccount",
                                            "plural": false,
                                            "selections": [
                                                (v31 /*: any*/),
                                                (v32 /*: any*/),
                                                (v33 /*: any*/),
                                                (v34 /*: any*/),
                                                (v3 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "coach",
                                            "kind": "LinkedField",
                                            "name": "coach",
                                            "plural": false,
                                            "selections": [
                                                (v3 /*: any*/),
                                                (v35 /*: any*/),
                                                (v36 /*: any*/),
                                                (v37 /*: any*/),
                                                (v38 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": (v39 /*: any*/),
                                                    "concreteType": "coachLocation",
                                                    "kind": "LinkedField",
                                                    "name": "coachLocations",
                                                    "plural": true,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v3 /*: any*/)
                                                    ],
                                                    "storageKey": "coachLocations(limit:1)"
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v39 /*: any*/),
                                                    "concreteType": "coachDiscipline",
                                                    "kind": "LinkedField",
                                                    "name": "coachDisciplines",
                                                    "plural": true,
                                                    "selections": [
                                                        (v40 /*: any*/),
                                                        (v41 /*: any*/),
                                                        (v3 /*: any*/)
                                                    ],
                                                    "storageKey": "coachDisciplines(limit:1)"
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        (v44 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": (v46 /*: any*/),
                                            "concreteType": "userOrganizerRole",
                                            "kind": "LinkedField",
                                            "name": "userOrganizerRoles",
                                            "plural": true,
                                            "selections": [
                                                (v47 /*: any*/),
                                                (v48 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "organizer",
                                                    "kind": "LinkedField",
                                                    "name": "organizer",
                                                    "plural": false,
                                                    "selections": [
                                                        (v3 /*: any*/),
                                                        (v35 /*: any*/),
                                                        (v40 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v49 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": (v50 /*: any*/),
                                                            "concreteType": "event",
                                                            "kind": "LinkedField",
                                                            "name": "events",
                                                            "plural": true,
                                                            "selections": [
                                                                (v35 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "eventMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "eventMetadata",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v8 /*: any*/),
                                                                        (v3 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v3 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v3 /*: any*/)
                                            ],
                                            "storageKey": "userOrganizerRoles(order_by:[{\"organizer\":{\"created_at\":\"asc\"}}],where:{\"organizer\":{\"deleted_at\":{\"_is_null\":true}}})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "registration",
                                            "kind": "LinkedField",
                                            "name": "registrations",
                                            "plural": true,
                                            "selections": [
                                                (v51 /*: any*/),
                                                (v52 /*: any*/),
                                                (v43 /*: any*/),
                                                (v53 /*: any*/),
                                                (v54 /*: any*/),
                                                (v3 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "userRidingInterest",
                                            "kind": "LinkedField",
                                            "name": "userRidingInterests",
                                            "plural": true,
                                            "selections": [
                                                (v55 /*: any*/),
                                                (v56 /*: any*/),
                                                (v57 /*: any*/),
                                                (v58 /*: any*/),
                                                (v59 /*: any*/),
                                                (v3 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "f90cd77ea6aa2bb4e91183090dfe077a",
            "id": null,
            "metadata": {},
            "name": "AuthProviderQuery",
            "operationKind": "query",
            "text": "query AuthProviderQuery(\n  $userId: String!\n) {\n  user_connection(where: {id: {_eq: $userId}}) {\n    edges {\n      node {\n        id\n        timezone\n        isAdmin\n        isCoach\n        isCreator\n        slug\n        email\n        firstName\n        lastName\n        idealRide\n        cyclingGoal\n        dob\n        phone\n        currency\n        profilePicUrl\n        showSetupCoach\n        selectedOrganizerSlug\n        stripeConnectId\n        stripeIdentityVerificationStatus\n        stripeIdentityVerificationError\n        stripeIdentityVerificationSessionId\n        userAddresses(where: {isDefault: {_eq: true}}) {\n          isDefault\n          city\n          state\n          country\n          zipCode\n          countryCode\n          id\n        }\n        stripeConnectAccount {\n          accountId\n          ownerUserId\n          chargesEnabled\n          payoutsEnabled\n          id\n        }\n        coach {\n          id\n          cuid\n          currencyCode\n          allowRequests\n          showProfileHelpBanner\n          coachLocations(limit: 1) {\n            timezone\n            id\n          }\n          coachDisciplines(limit: 1) {\n            name\n            skills\n            id\n          }\n        }\n        userSavedEvents(order_by: {created_at: asc}) {\n          id\n          cuid\n          eventCuid\n        }\n        userOrganizerRoles(where: {organizer: {deleted_at: {_is_null: true}}}, order_by: [{organizer: {created_at: asc}}]) {\n          organizerCuid\n          role\n          organizer {\n            id\n            cuid\n            name\n            slug\n            showOnboarding\n            events(where: {deleted_at: {_is_null: true}, clinics: {clinicCoaches: {coach: {userId: {_eq: $userId}}}}}) {\n              cuid\n              eventMetadata {\n                slug\n                id\n              }\n              id\n            }\n          }\n          id\n        }\n        registrations {\n          status\n          for\n          eventCuid\n          rideCuid\n          clinicCuid\n          id\n        }\n        userRidingInterests {\n          disciplineName\n          focus\n          hasAbilityGoal\n          abilityLevel\n          abilityLevelGoal\n          id\n        }\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'b8c97d40f8da4c8d8f54799309948c03';
export default node;
